import { render, staticRenderFns } from "./GerarCteForm.vue?vue&type=template&id=9f5970cc"
import script from "./GerarCteForm.vue?vue&type=script&lang=js"
export * from "./GerarCteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports